import * as CURRENCIES from "./currencies";

export default CURRENCIES;
export { type Currency } from "./types";
export const defaultCurrency = CURRENCIES[process.env.CURRENCY ?? "NGN"];
